import { useEffect } from 'react';
import { applyBrandToDocument, tenantBrandFor } from '../../lib/tenantBrand';

/** Wordmark height (px) — same as the sign-in page. */
const BRAND_LOGO_HEIGHT = 64;

/**
 * The logo at the top of the signed-out auth pages (forgot / reset password).
 * Signed out there is no tenant, so the hostname picks the brand
 * (aura.sunstellar.in → Sun Stellar), exactly as on the sign-in page. A host
 * without a brand keeps the AURA "A".
 */
export function AuthBrandMark() {
  const brand = tenantBrandFor(null);
  // These routes sit outside ThemeProvider; it leaves `.dark` on <html>.
  const darkSurface = typeof document !== 'undefined' && document.documentElement.classList.contains('dark');

  useEffect(() => { applyBrandToDocument(brand); }, [brand]);

  if (brand) {
    return (
      <img
        src={darkSurface ? brand.logoOnDark : brand.logoOnLight}
        alt={brand.name}
        width={Math.round(BRAND_LOGO_HEIGHT * brand.logoAspect)}
        height={BRAND_LOGO_HEIGHT}
        decoding="async"
        className="mx-auto block"
        style={{ height: BRAND_LOGO_HEIGHT, width: 'auto', maxWidth: '100%', objectFit: 'contain' }}
      />
    );
  }
  return (
    <div
      className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl text-xl font-bold"
      style={{
        background: 'linear-gradient(135deg, var(--ink-0), var(--ink-1))',
        color: 'var(--ivory-0)',
        fontFamily: 'var(--ff-serif)',
      }}
    >
      A
    </div>
  );
}
